export default "__VITE_ASSET__DLdP8KAh__"